import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import BetItemPayment from "@features/my-bets/mobile/common/BetItemPayment";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";

export default observer(function BetCardBodyDetails() {
	const { t } = useTranslation("mybets");
	const bet = useContext(MyBetsBetContext);

	return (
		<div className="bet--mini__details u-mar--top--xsml">
			<div className="bet--mini__row">
				<div className="bet--mini__col">
					<div className="bet--mini__col__title">
						{t<string>("ITEM.ADDITIONAL_MAX_COEFFICIENT")}:
					</div>
					<div className="bet--mini__col__title--bold">
						{bet.maxCoefficient.toFixed(2)}
					</div>
				</div>
				<div className="bet--mini__col">
					<div className="bet--mini__col__title">
						{t<string>("ITEM.INFO_PAYMENT_LABEL")}:
					</div>
					<div className="bet--mini__col__title--bold">
						{bet.displayPayment}
					</div>
				</div>
				<div className="bet--mini__col">
					<BetItemPayment />
				</div>
			</div>
		</div>
	);
});
